module.exports = __webpack_public_path__ + "img/图片10-1.be4bedea.png";